<script setup lang="ts">
import TechnoFrame from "@/components/Common/TechnoFrame.vue";
import GameInfo from "@/components/MainPage/PcVersion/GameInfo.vue";
import ScreenshotCarousel from "@/components/MainPage/PcVersion/ScreenshotsCarousel.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'GreetingsBlockContentHolder',
})
</script>

<template>
    <div class="contentBox">
        <TechnoFrame
            :offset="5"
            :size-modifier="0.3"
        />

        <div class="contentHolder">
            <GameInfo/>
            <ScreenshotCarousel/>
        </div>
    </div>
</template>

<style scoped lang="scss">
.contentBox {
    position: relative;
    width: 100%;
    max-width: 700px;
    background: rgba(15, 15, 15, 0.85);
    border-radius: 20px 20px 30px 30px;
    box-shadow: 0 0 20px 5px rgba(20, 20, 20, 1.0);

    background-image: v-bind('`url("/img/page/landing/main/bg/1.jpg")`');
    background-size: cover;
    background-position: center center;
}

.contentHolder {
    width: 100%;
    padding: 25px 20px 35px 20px;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    gap: 25px;
    justify-content: center;
    align-items: center;
}
</style>
